var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"van-fade"}},[(_vm.visible)?_c('div',{staticClass:"backtop",style:({
      'right': _vm.styleRight,
      'bottom': _vm.styleBottom
    }),on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_vm._t("default",function(){return [_c('van-icon',{attrs:{"name":"back-top","size":"16"}}),_c('span',[_vm._v("顶部")])]})],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }